/* eslint-disable */

import { AddOn } from './AddOn';
//import * as wording from '../../../common/js/wording'
import { AddOnType } from '../FbbEnum';
import * as log from '../../../common/js/appLogger';

/*
Pls submit “Z,1” for equipList plus below values (like Norton):

WiFi路由器	VAS Code	標準月費	Mktg code	收費總額	合約期(月)	合約代號	T&C
Asus RT-AC68U	FBRM1	$40	MVZ08	$960	24	LDJ24M40	N003PB
*/
export class AddOnBuyMeshRouter extends AddOn {
	static readonly codesInfo = [
		{
			//"avgPrice" : 699,
			amount: 1,
			ignorePlanCode: true,
			planCodeAllowed: ['all'],
			code: 'MESH-BUYX1',
		},
		{
			//"avgPrice" : 699,
			amount: 2,
			ignorePlanCode: true,
			planCodeAllowed: ['all'],
			code: 'MESH-BUYX2',
		},
	];

	constructor() {
		super();
		this.key = 'AddOnBuyMeshRouter';

		this.boxIconEn = '';
		this.boxIconZh = '';
		this.boxNameEn = 'Buy Mesh Router';
		this.boxNameZh = 'Buy Mesh Router';
		this.boxAmount = 699;
		this.discountAmount = -1;
		this.boxCount = 0;
		this.hasRedCounter = false;

		this.type = AddOnType.SINGLE;
	}

	public isAddOnSelected(): boolean {
		return this.boxCount > 0;
	}

	//=================================================================================
	/** no overwrite AddOn one 
    public getData() : any {
        //var data = super.getData()
        return data
    }
    public parse(data: any) {
        //super.parse(data)
    }
    */
	//=================================================================================

	public getPlanVasCode2(amount: Number, planCode: string): string {
		let vasCode;
		if (this.isAddOnSelected()) {
			let option = null;
			for (var i = 0; i < AddOnBuyMeshRouter.codesInfo.length; i++) {
				if (AddOnBuyMeshRouter.codesInfo[i].amount == amount) {
					if ((AddOnBuyMeshRouter.codesInfo[i].ignorePlanCode ?? false) == true) {
						option = AddOnBuyMeshRouter.codesInfo[i];
						break;
					} else {
						if (AddOnBuyMeshRouter.codesInfo[i].planCodeAllowed.indexOf(planCode) > -1) {
							option = AddOnBuyMeshRouter.codesInfo[i];
							break;
						}
					}
				}
			}

			vasCode = option?.code ?? '';
			return vasCode;
		} else {
			return '';
		}
	}
}
